module.exports = __webpack_public_path__ + "media/images/captive_portal/user_management-02a62f4cddfadd14a0d39e14c429d63b.svg";